// NK Bridal Australia — Brand Photo Library
// Reference collection of Nancy's studio photos for use across the website & print assets.
// Uploaded 2026-08-29. Each entry: url + description + suggested use.
// URLs verified visually 2026-08-31.

export const PHOTO_LIBRARY = {
  laceSleeveChampagne: {
    url: "https://customer-assets-jai6qajn.emergentagent.net/job_bridal-australia-hub/artifacts/2f1nidei_hf_20260829_075009_9399ed37-75db-4769-91ce-e944e4414ec6.png",
    description: "Nancy in a champagne slip dress inspecting a lace sleeve of a gown on a mannequin; chandeliers and gown racks behind. Warm, luxe boutique.",
    suggestedUse: "Hero / collections editorial / bridal pamphlet front — premium editorial feel.",
  },
  steamingPinkRobe: {
    url: "https://customer-assets-jai6qajn.emergentagent.net/job_bridal-australia-hub/artifacts/n7ohp6wq_hf_20260829_074931_c78b98bd-779b-4d18-928d-ac95a9459d35.png",
    description: "Nancy in a soft pink robe steaming a hanging gown by a bright window; gold rails, swatch card.",
    suggestedUse: "Alterations / garment-care section; process step imagery.",
  },
  adjustingLaceChampagne: {
    url: "https://customer-assets-jai6qajn.emergentagent.net/job_bridal-australia-hub/artifacts/8qd2m76r_hf_20260829_073922_fea2995e-6aec-4e83-9f97-7433e879bb73%20%281%29.png",
    description: "Nancy in a champagne slip dress adjusting lace detail on a mannequin beside a large window; bright, airy Perth studio.",
    suggestedUse: "About / 'Meet Nancy' / bright secondary hero.",
  },
  measuringBrideCamel: {
    url: "https://customer-assets-jai6qajn.emergentagent.net/job_bridal-australia-hub/artifacts/06jn3m8s_hf_20260829_073012_4a349be9-8946-4eba-bf6b-fb32925068d1.png",
    description: "Nancy in a camel coat with tape measure and pearl pin cushion, measuring a bride's waist in front of an ornate mirror.",
    suggestedUse: "Alterations hero / fittings & measurements section.",
  },
  steamingBlackDress: {
    url: "https://customer-assets-jai6qajn.emergentagent.net/job_bridal-australia-hub/artifacts/amolnixo_hf_20260829_072401_dc04abf0-e0fd-4e40-af6e-824e7a64c153.png",
    description: "Nancy in an elegant black dress steaming a beaded lace gown by the window; gold trim, refined.",
    suggestedUse: "Alterations / finishing & pressing; sophisticated dark-outfit contrast shot.",
  },
  consultationLookbook: {
    url: "https://customer-assets-jai6qajn.emergentagent.net/job_bridal-australia-hub/artifacts/l2k0lcbv_hf_20260831_085512_da773170-8100-4b28-a874-853c760921da.png",
    description: "Nancy in a navy gown showing lace fabric to a seated bride, an open lookbook of gown sketches on the coffee table; warm, personal consultation.",
    suggestedUse: "Process 'Enquiry & Consultation' (in use); booking / contact; consultation storytelling.",
  },
  heroSteamingPinkFitted: {
    url: "https://customer-assets-jai6qajn.emergentagent.net/job_bridal-australia-hub/artifacts/aoh5yqxv_hf_20260831_085404_2ea9102e-f5ce-4e18-8378-60f9ece0b171.png",
    description: "Nancy in a fitted blush-pink wrap dress steaming a beaded lace gown by a bright window; gold-trimmed mirror, luxe.",
    suggestedUse: "Homepage hero (in use); premium editorial lead image.",
  },
  handStitchTan: {    url: "https://customer-assets-jai6qajn.emergentagent.net/job_bridal-australia-hub/artifacts/zaopw71t_hf_20260829_072117_45407b17-63ba-45de-8b10-1fa587720d48.png",
    description: "Nancy in a tan blazer hand-stitching lace (needle, no pins in mouth). Currently used on both A5 flyer fronts.",
    suggestedUse: "A5 flyer fronts (in use); alterations craftsmanship.",
  },
};

export default PHOTO_LIBRARY;
